import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { ROLE_SI_ADMIN, useAuth } from '@/contexts/AuthContext';
import { useToast } from '@/hooks/useToast';
import { onboardingSessaoService, type SessaoOnboardingDados } from './onboardingSessaoService';

const chave = (documentoId: string) => ['si', 'onboarding-sessoes', documentoId] as const;

/** Sessões de um documento de onboarding — só pro SI (regra fechada pros demais). */
export function useOnboardingSessoes(documentoId: string) {
  const { userHasRole } = useAuth();
  return useQuery({
    queryKey: chave(documentoId),
    queryFn: () => onboardingSessaoService.listarPorDocumento(documentoId),
    enabled: userHasRole(ROLE_SI_ADMIN),
  });
}

export function useOnboardingSessaoMutations(documentoId: string) {
  const queryClient = useQueryClient();
  const toast = useToast();
  const { user } = useAuth();
  const por = { id: user?.collaboratorId ?? user?.uid ?? '', name: user?.displayName ?? user?.email ?? '' };
  const invalidar = () => queryClient.invalidateQueries({ queryKey: chave(documentoId) });
  return {
    salvar: useMutation({
      mutationFn: (sessao: SessaoOnboardingDados & { id?: string }) => onboardingSessaoService.salvar(sessao, por),
      onSuccess: () => {
        toast.success('Sessão de onboarding salva.');
        invalidar();
      },
      onError: () => toast.error('Não foi possível salvar a sessão. Tente de novo.'),
    }),
    excluir: useMutation({
      mutationFn: (id: string) => onboardingSessaoService.excluir(id),
      onSuccess: () => {
        toast.success('Sessão excluída.');
        invalidar();
      },
      onError: () => toast.error('Não foi possível excluir a sessão.'),
    }),
  };
}
